// React imports.
import React, { Component } from "react";

// App imports.
import { IndexCodeEnum } from "../utility";

const SelectionScreen = ({ state }) => (
  <div >
    <h2>Time to Explore – Select your State and Index</h2>
    <br />
    <p>
      Now that you have re-familiarized yourself with the LIHEAP Targeting Indices, we can go ahead and explore your own index values in more detail.
    </p>

    {/*state.UserInfo.viewAll === true &&*/
      <React.Fragment>
        <p>
          Please select your State and the Index you would like to explore below. (Note: No matter which index you choose, you can always come back and explore the other one later by restarting the tool.)
        </p>

        <label>
          Select a state:
          <select className="form-control" style={{ height: 25, width: "15%" }} id="SelectedGranteeId" defaultValue={state.SelectedGranteeId} onChange={state.SelectStateFieldChangeHandler}>
            <option >Choose a state</option>
            {state.Grantees.map(grantee => {
              return (
                <option key={grantee.granteeId} value={grantee.granteeId}>{grantee.granteeName}</option>
              );
            })}
          </select>
        </label>
      </React.Fragment>
    }
    {/*state.UserInfo.viewAll != true &&
      <div>Your state is <strong>{state.UserInfo.granteeName}</strong>.
        Please select the Index you would like to explore below. (Note: No matter which index you choose, you can always come back and explore the other one later by restarting the tool.)
      </div>
    */}
    <br /><br />
    <label>
      <input type="radio"
        name="lboIndexCode"
        id="lboIndexCode_target"
        value={IndexCodeEnum.TargetingIndex}
        checked={state.SelectedIndexCode === IndexCodeEnum.TargetingIndex}
        onChange={(changeEvent) => state.lboIndexCodeFieldChangeHandler(changeEvent)}
      />
      <span>Benefit Targeting Index</span>
    </label>
    <br />
    <label>
      <input type="radio"
        name="lboIndexCode"
        id="lboIndexCode_burden"
        value={IndexCodeEnum.BurdenReductionIndex}
        checked={state.SelectedIndexCode === IndexCodeEnum.BurdenReductionIndex}
        onChange={(changeEvent) => state.lboIndexCodeFieldChangeHandler(changeEvent)}
      />
      <span>Burden Reduction Targeting Index</span>
    </label>
    <br /><br />

  </div>
);

export default SelectionScreen;
